import { render, staticRenderFns } from "./LevTablePagination.vue?vue&type=template&id=f68efd00"
import script from "./LevTablePagination.vue?vue&type=script&lang=js"
export * from "./LevTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports